// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1MLQG","label":"Labeled_label__HiEaO","divider":"Labeled_divider__15kT1"};